import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useSnackbar } from "notistack5";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { updateLocationDataApi } from "src/Api/Services/SystemConfiguration";

const UpdateLocation = ({ data, fetchData }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formik = useFormik({
    initialValues: data,
    onSubmit: () => {
      handleSubmitApiCall();
    },
  });
  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    values,
    handleBlur,
    resetForm,
    setSubmitting,
  } = formik;
  const handleChange = (e) => {
    let { name, value } = e.target;
    if (
      ["airlines", "origins", "destinations", "blacklistAirports"].includes(
        name
      )
    )
      value = value.toUpperCase();
    formik.setFieldValue(name, value);
  };
  const handleSubmitApiCall = async () => {
    try {
      const { data } = await updateLocationDataApi(values);
      if (data.status) {
        fetchData();
        resetForm();
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
    setSubmitting(false);
  };
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col md={12} xs={12} xl={3}>
          <TextField
            type="text"
            placeholder="Enter airline code"
            size="normal"
            label="Airline"
            name="airlines"
            value={values.airlines}
            onChange={handleChange}
            error={errors.airlines && touched.airlines}
            fullWidth
            onBlur={handleBlur}
          />
          {errors.airlines && touched.airlines && (
            <FormHelperText error id="component-error-text">
              {errors.airlines}
            </FormHelperText>
          )}
        </Col>
        <Col md={12} xs={12} xl={3}>
          <TextField
            type="text"
            placeholder="Enter origin code"
            size="normal"
            label="Origin"
            name="origins"
            value={values.origins}
            onChange={handleChange}
            error={errors.origins && touched.origins}
            fullWidth
            onBlur={handleBlur}
          />
          {errors.origins && touched.origins && (
            <FormHelperText error id="component-error-text">
              {errors.origins}
            </FormHelperText>
          )}
        </Col>
        <Col md={12} xs={12} xl={3}>
          <TextField
            type="text"
            placeholder="Enter destination code"
            size="normal"
            label="Destination"
            name="destinations"
            value={values.destinations}
            onChange={handleChange}
            error={errors.destinations && touched.destinations}
            fullWidth
            onBlur={handleBlur}
          />
          {errors.destinations && touched.destinations && (
            <FormHelperText error id="component-error-text">
              {errors.destinations}
            </FormHelperText>
          )}
        </Col>
        <Col md={12} xs={12} xl={3}>
          <TextField
            type="text"
            placeholder="Enter blacklist airport code"
            size="normal"
            label="Blacklist Airport"
            name="blacklistAirports"
            value={values.blacklistAirports}
            onChange={handleChange}
            error={errors.blacklistAirports && touched.blacklistAirports}
            fullWidth
            onBlur={handleBlur}
          />
          {errors.blacklistAirports && touched.blacklistAirports && (
            <FormHelperText error id="component-error-text">
              {errors.blacklistAirports}
            </FormHelperText>
          )}
        </Col>
        <Col md={12} xs={12} xl={3} className="mt-4">
          <FormControl fullWidth size="normal">
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              name="status"
              value={values.status}
              onChange={handleChange}
              error={errors.status && touched.status}
              label="Status"
              onBlur={handleBlur}
            >
              <MenuItem value={true}>Active</MenuItem>
              <MenuItem value={false}>Inactive</MenuItem>
            </Select>
          </FormControl>
          {errors.status && touched.status && (
            <FormHelperText error id="component-error-text">
              {errors.status}
            </FormHelperText>
          )}
        </Col>
      </Row>
      <div className="text-center mt-4">
        <Button variant="contained" type="submit" disabled={isSubmitting}>
          Submit
        </Button>
      </div>
    </form>
  );
};

export default UpdateLocation;
